<template>
    <div>
        <div ref="holder" v-if="asset" class="holder">
            <img :src="thumbnail.url">
        </div>
        <span class="helper-text"><i class="fa fa-zoom"></i> Hover to zoom</span>
    </div>
</template>

<script>
    import {  } from "jquery-zoom";

    export default {
        props: {
            asset: {
                type: Object
            }
        },
        mounted() {
            $(this.$refs.holder).zoom({url: this.asset.url});
        },
        watch: {
            thumbnail() {
                $(this.$refs.holder).zoom({url: this.asset.url});
            }
        },
        computed: {
            thumbnail() {
                let thumbnail = _.find(this.asset.transforms, transform => {
                    return transform.handle = 'large_thumbnail';
                });

                return thumbnail ? thumbnail : this.asset;
            }
        }
    }
</script>

<style scoped>
    .holder {
        text-align: center;
        border:1px solid #ebebeb;
        border-radius:4px;
        padding:1em 0;
    }
    .helper-text {
        text-align:center;
        display:block;
        padding:.5em 0;
        background-color:#ebebeb;
        color:darken(#ebebeb, 2%);
        font-size:.875em;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/ImageZoom.vue